import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Layout from '../App/layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'
import JournalEntryFormatsIndexContainer from './JournalEntryFormatsIndexContainer'

class JournalEntryFormatIndexPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired
    }

    componentDidMount() {
        document.title = 'Journal Entry Formats | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                    { path: '/journal_entry_formats', name: 'Journal Entry Formats' }
                ]}>
                    <ContentLayout>
                      <JournalEntryFormatsIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default JournalEntryFormatIndexPage
